import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Macos = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="m12.796 20-.23-2.016c-.188.01-.376.016-.566.016-3.8 0-7-2.133-7-5h2c0 1.551 2.173 3 5 3 .113 0 .226-.002.337-.007L12.108 14H8.792l1.904-10H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7.796Zm2.014 0H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-6.268l-1.523 8h2.683l.419 3.65C15.928 15.128 17 14.09 17 13h2c0 2.195-1.874 3.959-4.458 4.666L14.81 20ZM5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm1 5h2v3H6V7Zm10 0h2v3h-2V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Macos;
